import { render, staticRenderFns } from "./RolePermissionsEditor.vue?vue&type=template&id=cd6f6022&scoped=true"
import script from "./RolePermissionsEditor.vue?vue&type=script&lang=js"
export * from "./RolePermissionsEditor.vue?vue&type=script&lang=js"
import style0 from "./RolePermissionsEditor.vue?vue&type=style&index=0&id=cd6f6022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6f6022",
  null
  
)

export default component.exports